import React, { useEffect } from 'react'
import CreateCategory from '../../components/Categories/CreateCategory'
import CategoriesList from '../../components/Categories/CategoriesList'
import { updateLastActive } from '../../utils/templatesApi'

const Category = ({ setHeading, userId }) => {
  console.log('userId: ', userId);
  const [open, setOpen] = React.useState(false)
  const [refresh, setRefresh] = React.useState(false)
  const handleOpen = () => {
    setOpen(true)
    updateLastActive(userId, new Date())
  }
  const handleClose = () => {
    setOpen(false)
    updateLastActive(userId, new Date())
  }
  useEffect(() => {
    setHeading('Categories')
  }, [])
  return (
    <div>
      <CreateCategory
        setRefresh={setRefresh}
        handleOpen={handleOpen}
        handleClose={handleClose}
        open={open}
        userId={userId}
      />
      <CategoriesList
        refresh={refresh}
        handleOpen={handleOpen}
        handleClose={handleClose}
        open={open}
        userId={userId}
      />
    </div>
  )
}

export default Category
